<template>
    <div class="sysLogPage">
        <v-search :formContent="formContent" :SearchForm="SearchForm" :inline="true" :optareBtn="optareBtn" class="search"
            @DelFn="DelFn" @resetFn="resetFn" @searchFn="getListFn" @confirmFn="getListFn">
            <div class="logPonit">
                <ArrowButton @click="logPointFn">{{ $t('syslog.log_trig_setting') }}</ArrowButton>
            </div>
        </v-search>
        <div class="componentPage">
            <tablePage :tableData="tableData" :loading="loading" @choozeTableFn="choozeTableFn" @detailRow="detailRow"
                @delRow="delRow" />
            <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"
                :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
        </div>
        <detailDialog :isShow.sync="isShow" :title="title" :detailObj="detailObj" />
        <!-- 日志触发点 -->
        <setDialog :isSet.sync="isSet" :treeData="treeData" :isLogLoading="isLogLoading" :rangeArray="rangeArray" />
    </div>
</template>

<script>
// import { shareScope } from '@/api/modules/public.js';
import ArrowButton from '../../components/ArrowButton/ArrowButton.vue';
import getRange from '@/utils/getRange.js';
import { sysLogPage, sysLogDel, sysLogDetail, sysLogTree,getModuleList } from '@/api/modules/operateLog.js';
import mixinForm from '@/utils/formMixins.js';
import {getIsSys} from "@/utils/permission";

import tablePage from './components/LogTable.vue';
import detailDialog from './components/detailDialog.vue';
import setDialog from './components/logPointDialog.vue';

export default {
    mixins: [mixinForm, getRange],
    components: {
        tablePage,
        detailDialog,
        setDialog,
        ArrowButton
    },
    computed: {
        i18n() {
            return this.$i18n.locale;
        },
        isSysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            return (currentUser.sysScope && currentUser.sysAdmin) || (currentUser.sysScope && !currentUser.sysAdmin);
        }
    },
    data() {
        return {
            detailObj: {},
            isSet: false,
            choozeTable: [],
            formContent: [
                {
                    id: 2,
                    text: 'syslog.func_module',
                    type: 'select',
                    paramsName: 'module',
                    isChooze: true,
                    selectParam:[]
                },
                {
                    id: 3,
                    text: 'syslog.time',
                    type: 'datetimerange',
                    paramsName: 'time',
                    isChooze: false
                },
                {
                    id: 4,
                    text: 'syslog.operation',
                    type: 'input',
                    paramsName: 'action',
                    isChooze: false
                },
                {
                    id: 5,
                    text: 'syslog.operator',
                    type: 'input',
                    paramsName: 'operator',
                    isChooze: false
                },
                {
                    id: 6,
                    text: 'public.table_scope',
                    type: 'select',
                    paramsName: 'scopeId',
                    selectParam: [],
                    isChooze: false
                }
            ],
            SearchForm: {
                scopeId: null,
                module: null,
                startTime: null,
                endTime: null,
                time: [],
                action: null,
                operator: null
                // type: '0'
            },
            optareBtn: [
                {
                    id: 1,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'public.btn_delete',
                    method: 'DelFn'
                }
            ],
            treeData: [],
            isLogLoading: false,
            rangeArray: []
        };
    },
    created() {
        if (!this.isSysAdmin) {
            this.formContent.pop();
        }
        this.initModuleList();

        this.getRangeFn();
    },
    methods: {
        getRangeFn() {
            this.getRange().then(({ result }) => {
                this.rangeArray = this.formContent[this.formContent.length - 1].selectParam = result.filter(item => {
                    (item.value = item.id), (item.label = item.name);
                    return item.id > 0;
                });
            });
        },
        initModuleList(){
            const moduleIndex =  this.formContent.findIndex(item=>item.paramsName === 'module');
            if(getIsSys()){
                getModuleList().then(res=>{
                    if(res.result && res.result.length){
                        console.log(moduleIndex);
                        console.log('1111111111', res.result );
                        if(moduleIndex !== -1){
                            this.$set(this.formContent[moduleIndex],'selectParam',res.result.map((item,index)=>{
                                return {
                                    id:index,
                                    label:'modules.' + item,
                                    value:item
                                }

                            }));
                        }
                    }
                })
            }else{
                this.formContent.splice(moduleIndex,1);
            }
            console.log('this.formContent[moduleIndex]=', this.formContent[moduleIndex])
        },
        getListFn() {
            this.loading = true;
            if (this.SearchForm.time && this.SearchForm.time.length > 0) {
                this.SearchForm.startTime = this.$dateParseTime(this.SearchForm.time[0]);
                this.SearchForm.endTime = this.$dateParseTime(this.SearchForm.time[1]);
            }
            let query = { ...this.SearchForm };
            delete query.time;
            sysLogPage(query)
                .then(({ result, pageInfo }) => {
                    this.tableData = result;
                    this.total = pageInfo.total;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        delRow(row) {
            this.TODOTIPDEL([row.id]);
        },
        detailRow(row) {
            this.isShow = true;
            this.title = `[${this.$timetransition(row.recordTime)}] ${this.$t('syslog.operation_detail')}`;
            sysLogDetail({ id: row.id }).then(({ result }) => {
                this.detailObj = result;
            });
        },
        resetFn() {
            this.SearchForm = {
                scopeId: null,
                module: null,
                startTime: null,
                endTime: null,
                time: [],
                action: null,
                operator: null,
                iDisplayStart: 0,
                iDisplayLength: 15
                // type: '0'
            };
            this.getListFn();
        },
        /** 表格勾选 */
        choozeTableFn(array) {
            this.choozeTable = array;
        },
        DelFn() {
            if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            let ids = this.choozeTable.map(item => item.id);
            this.TODOTIPDEL(ids);
        },
        /**
         *
         * @param {*param 选中数据id} param string
         */
        TODOTIPDEL(param) {
            this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_confirm'), // 确定按钮的文案
                cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                type: 'warning'
            })
                .then(() => {
                    sysLogDel(param).then(({ result }) => {
                        if (result === 1) {
                            this.getListFn();
                            this.$message.success(this.$t('public.tip_del_succ').toString());
                        } else {
                            this.$message.error('public.tip_del_fail');
                        }
                    });
                })
                .catch(() => { });
        },
        logPointFn() {
            this.isSet = true;
            this.isLogLoading = true;
            // , local: this.i18n
            sysLogTree({ scopeId: this.$store.getters.userInfo.scope.sceneId, local: this.i18n })
                .then(({ result }) => {
                    this.treeData = result.item || [];
                })
                .finally(() => {
                    this.isLogLoading = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.sysLogPage {
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    .search {
        position: relative;

        .logPonit {
            position: absolute;
            right: 0;
            top: 10px;

            span {
                color: #fff;
                font-size: 14px;
                font-weight: bold;
            }

            i {
                color: #fff;
                float: right;
                line-height: 30px;
            }
        }
    }

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}
</style>
